if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.isExpanded = false;

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        slides: this.querySelectorAll('[id^="Slide-template"]')
      }

      this.updateSliderHeight = this.updateSliderHeight.bind(this);
      this.handleShowMore = this.handleShowMore.bind(this);


      const sizeObserver = new ResizeObserver(this.updateSliderHeight);
      sizeObserver.observe(this.elements.viewer);

      this.setupShowMoreButton();

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    setupShowMoreButton() {
      const showMoreBtn = this.querySelector('.show-more');
      if (!showMoreBtn) return;
      
      showMoreBtn.removeEventListener('click', this.handleShowMore);
      showMoreBtn.addEventListener('click', this.handleShowMore);
    }

    handleShowMore() {
      const productGallery = this.querySelector('product-gallery');
      const showMoreBtn = productGallery.querySelector('.show-more');
      
      this.isExpanded = true;

      productGallery.style.height = 'auto';
      showMoreBtn.style.display = 'none';
    }

    updateSliderHeight() {
      if (this.isExpanded) return;

      this.mql = window.matchMedia('(min-width: 750px)');

      if (this.mql.matches) {
        this.visibleSlidesMaxCount = 8;
        const visibleSlides = Array.from(this.elements.slides).filter((slide) => {
          if (slide.classList.contains('wide')) {
            this.visibleSlidesMaxCount = this.visibleSlidesMaxCount - 1;
          }

          return slide.checkVisibility();
        });

        if (visibleSlides.length > this.visibleSlidesMaxCount) {
          this.slidesGap = 1;
          this.maxHeight = Array.from(this.elements.slides)
            .slice(0, this.visibleSlidesMaxCount)
            .filter((_slide, idx) => idx % 2 === 0)
            .reduce((acc, slide) => acc + slide.clientHeight + this.slidesGap, 0);
          
          const productGallery = this.querySelector('product-gallery');
          const showMoreBtn = productGallery.querySelector('.show-more');

          showMoreBtn.style.display = 'flex';
          showMoreBtn.offsetHeight;
          
          const productGalleryHeight = (this.maxHeight + showMoreBtn.clientHeight) - this.slidesGap;
          productGallery.style.height = `${productGalleryHeight}px`;
        }
      } else {
        const productGallery = this.querySelector('product-gallery');
        const showMoreBtn = productGallery.querySelector('.show-more');

        productGallery.style.height = 'auto';
        if (showMoreBtn) showMoreBtn.style.display = 'none';
      }
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
